type LogLevel = 'info' | 'warn' | 'error';

class Logger {

  log(message: string, level: LogLevel = 'info') {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[${level.toUpperCase()}] ${message}`);
    }
  }

  info(message: string) {
    this.log(message, 'info');
  }

  warn(message: string) {
    this.log(message, 'warn');
  }

  error(message: string) {
    this.log(message, 'error');
  }

}

export const logger = new Logger();
